/**
 * Users API endpoints
 */
import { apiClient } from '../client'

export interface User {
  id: number
  email: string
  full_name: string | null
  is_active: boolean
  is_superuser: boolean
  roles: Array<{ id: number; name: string }>
  organizations?: Array<{ id: number; name: string }> // Deprecated: Single-tenant mode, not used for filtering
  created_at: string
  updated_at: string
}

export interface UserCreate {
  email: string
  password: string
  full_name?: string
  is_active?: boolean
  role_ids?: number[]
  // Single-tenant: organization_ids and primary_organization_id removed
}

export interface UserUpdate {
  email?: string
  full_name?: string
  password?: string
  is_active?: boolean
  role_ids?: number[]
  // Single-tenant: organization_ids and primary_organization_id removed
}

export const usersApi = {
  /**
   * List users (single-tenant: no organization filtering)
   */
  async list(params?: {
    skip?: number
    limit?: number
  }): Promise<User[]> {
    const response = await apiClient.get<User[]>('/api/v1/users', { params })
    return response.data
  },

  /**
   * Get user by ID
   */
  async get(id: number): Promise<User> {
    const response = await apiClient.get<User>(`/api/v1/users/${id}`)
    return response.data
  },

  /**
   * Create user
   */
  async create(data: UserCreate): Promise<User> {
    const response = await apiClient.post<User>('/api/v1/users', data)
    return response.data
  },

  /**
   * Update user
   */
  async update(id: number, data: UserUpdate): Promise<User> {
    const response = await apiClient.put<User>(`/api/v1/users/${id}`, data)
    return response.data
  },

  /**
   * Delete user
   */
  async delete(id: number): Promise<void> {
    await apiClient.delete(`/api/v1/users/${id}`)
  },
}

